// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionStringBuilderConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get CONNECTION_STRING_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('LICENSE_CHECKER_MESSAGE_CONNECTION_STRING_CONSTRAINT')
      }
    };
  },
  get SERVER_NAME_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('CONNECTION_STRING_BUILDER_REQUIRED_SERVER_NAME')
      }
    };
  },
  get DATABASE_CONSTRAINT() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('CONNECTION_STRING_BUILDER_REQUIRED_DATABASE')
      }
    };
  },

  get AUTHENTICATION_TYPES() {
    return {
      Standard: {
        value: localizer.getText('CONNECTION_STRING_BUILDER_STANDARD_AUTHENTICATION'),
        displayPattern: `{0} ${localizer.getText('CONNECTION_STRING_BUILDER_TEXT_AUTHENTICATION')}`,
        connectionStringPattern: 'server={0};database={1};User Id={2};Password={3};'
      },
      Trusted: {
        value: localizer.getText('CONNECTION_STRING_BUILDER_TRUSTED_AUTHENTICATION'),
        displayPattern: `Windows ${localizer.getText('CONNECTION_STRING_BUILDER_TEXT_AUTHENTICATION')}`,
        connectionStringPattern: 'server={0};database={1};Trusted_Connection=True;'
      }
    };
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ConnectionStringBuilderConstants.js